export function getProfilePathForRole(role) {
  const r = String(role || "").trim().toUpperCase();
  if (r === "CUSTOMER") return "/profile";
  if (r === "CAREGIVER") return "/caregiver/complete-profile";
  if (r === "CARE_MANAGER") return "/care-manager/profile";
  if (r === "ADMIN" || r === "OPS") return "/admin";
  return "/profile";
}
